import * as v from 'valibot';

import type { MaoAirport } from '../types';

export const maoAirportSchema: v.GenericSchema<MaoAirport> = v.object({
  Latitude: v.number('Airport latitude is missing'),
  Longitude: v.number('Airport longitude is missing'),
  Id: v.number('Airport ID is missing'),
  IATA: v.nullable(v.string('Invalid IATA code')),
  ICAO: v.string('ICAO code is missing'),
  ServedCity: v.nullish(v.string('Invalid served city')),
  ServedCityArea: v.nullish(
    v.object({
      Code: v.string('Served city area code is missing'),
    }),
  ),
  Country: v.object({
    Name: v.string('Country name is missing'),
  }),
  IanaTimeZone: v.string('IANA timezone is missing'),
});
